
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.container-background{
  background-image:var(--background-url-sm);
  position:relative;
  height:100%;
  display:flex;
  width:100%;
  overflow:hidden;
  background-attachment:fixed;
  background-position:center;
  background-repeat:no-repeat;
  background-size:cover;
}

  @media (min-width: 768px){.container-background{
    background-image:var(--background-url-md)
}
  }

  @media (min-width: 1024px){.container-background{
    background-image:var(--background-url-lg)
}
  }

  @media (min-width: 1380px){.container-background{
    background-image:var(--background-url-ultra)
}
  }

@media (prefers-reduced-motion: reduce){
  .container-background{
    background-attachment:unset;
  }
}
`;